// extracted by mini-css-extract-plugin
export default {"list-dot":"ListDot_list-dot__Xk2dL","list-dot--checked":"ListDot_list-dot--checked__0NnDD"};